import * as Sentry from '@sentry/angular';
import { appConfig } from './app-config';

export const initSentry = () => {
  const sentryConfig = appConfig.sentry;
  if (sentryConfig.enabled) {
    Sentry.init({
      dsn: sentryConfig.dsn,
      integrations: [
        Sentry.replayIntegration({
          networkDetailAllowUrls: [
            window.location.origin,
            'https://letapps.letpension.dk',
            'https://letapps.letpension.dk/api/brugerauthorization/check',
            appConfig.apiRoot
          ],
          networkRequestHeaders: ['Cache-Control'],
          networkResponseHeaders: ['Referrer-Policy']
        }),
        Sentry.browserTracingIntegration()
      ],
      // Session Replay
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: sentryConfig.tracesSampleRate,
      tracePropagationTargets: [window.location.origin, appConfig.apiRoot],

      release: appConfig.buildNumber,
      environment: appConfig.env
    });
    console.log('Sentry initialized');
  }
};
